// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1767":"0c1b35ee67b182ed","9080":"fdf65b90d865e772","9618":"a6d3fa782776bdab","9776":"2790b0a96fe84169"}[chunkId] + ".js";
};